import { StaticQuery, graphql } from 'gatsby';
import React from 'react';

import PostList from '../components/PostList';
import { GhostPost } from '../models/ghost';

const BlogFeaturedPostsContainer: React.FC = () => {
  return (
    <StaticQuery
      query={graphql`
        {
          allGhostPost(
            sort: { order: DESC, fields: [published_at] }
            filter: {
              featured: { eq: true }
              primary_tag: { slug: { regex: "/^blog/" } }
            }
            limit: 3
          ) {
            edges {
              node {
                id
                title
                slug
                published_at
                excerpt
                custom_excerpt
                feature_image
              }
            }
          }
        }
      `}
      render={data => {
        const posts = data.allGhostPost.edges.map(
          (item: { node: Partial<GhostPost> }) => item.node
        );
        if (posts.length === 0) return <div>There are no featured posts.</div>;
        return <PostList posts={posts} />;
      }}
    />
  );
};

export default BlogFeaturedPostsContainer;
